import type { PublicStoryDetail, StoryCharacter, StoryDetail, StorySlide } from '@/shared/api/models'

/**
 * Map PublicStoryDetail to StoryDetail for BookViewer compatibility.
 * Layers and print_dimensions are available on public stories,
 * so this is mostly a passthrough with safe defaults for authenticated-only fields.
 */
export function toBookViewerStory(story: PublicStoryDetail): StoryDetail {
  const slides: StorySlide[] = story.slides.map((s) => ({
    id: s.id,
    slide_number: s.slide_number,
    slide_type: s.slide_type,
    page_start: s.page_start,
    page_end: s.page_end,
    left_page_editable: false,
    right_page_editable: false,
    background_image_url: s.background_image_url,
    parent_prompt: undefined,
    spread_id: null,
    layers: s.layers,
    cover_dimensions: null as unknown as StorySlide['cover_dimensions'],
    is_locked: false,
    created_at: s.created_at,
    updated_at: s.created_at,
  }))

  const storyCharacters: StoryCharacter[] = story.story_characters.map((c) => ({
    id: 0,
    character: 0,
    character_name: c.character_name,
    character_type: c.character_type,
    character_appearance: null,
    character_personality: null,
    character_role: c.character_role,
    order: c.order,
    reference_image_url: null,
    visual_dna: '',
    story_outfit: null,
  }))

  return {
    id: story.id,
    user: 0,
    reader_profile: null,
    reader_profile_name: null,
    title: story.title,
    status: 'COMPLETE' as StoryDetail['status'],
    cover_image_url: story.cover_image_url,
    character_reference_images: {} as StoryDetail['character_reference_images'],
    total_pages: story.total_slides,
    slides_count: story.slides_count,
    generation_progress: { total: 0, completed: 0, percentage: 100, status: 'complete' } as StoryDetail['generation_progress'],
    reader_metadata: story.reader_metadata as StoryDetail['reader_metadata'],
    template: null as unknown as StoryDetail['template'],
    print_dimensions: story.print_dimensions as StoryDetail['print_dimensions'],
    available_fonts: [],
    error_message: null,
    is_public: story.is_public,
    public_share_slug: story.public_share_slug,
    share_url: null,
    storefront_session_uuid: null,
    public_image_urls: undefined,
    is_favorite: false,
    is_archived: false,
    interested_in_book: false,
    is_preview: false,
    preview_slides_count: 0,
    is_locked: false,
    last_read_at: null,
    tags: null,
    art_style_id: null,
    created_at: story.created_at,
    updated_at: story.created_at,
    completed_at: story.completed_at,
    slides,
    story_characters: storyCharacters,
  }
}
